import {
	createComment,
	createReply,
	deleteComment,
	editComment,
	getCommentReactionCounts,
	getCommentReactions,
	getCommentsList,
	registerCommentReaction,
	unregisterCommentReaction,
	updateCommentReaction
} from "client/Api/Hub/Announcements/announcementComments";
import { doesUserHaveAccess, findUsers } from "client/Api/Hub/Announcements/announcementViewer";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { HubCommentSectionService } from "../HubCommentSection/HubCommentSection";

export function getAnnouncementCommentService(
	announcementId: number
): HubCommentSectionService {
	function withAnnouncementId<TArgs extends unknown[], TResult>(
		callback: (announcementId: number, ...args: TArgs) => Promise<TResult>
	): (...args: TArgs) => Promise<TResult> {
		return (...args: TArgs) => callback(announcementId, ...args);
	}

	return {
		createComment: withAnnouncementId(createComment),
		createReply: withAnnouncementId(createReply),
		deleteComment: withAnnouncementId(deleteComment),
		editComment: withAnnouncementId(editComment),
		getCommentReactionCounts: withAnnouncementId(getCommentReactionCounts),
		getCommentReactions: withAnnouncementId(getCommentReactions),
		registerCommentReaction: withAnnouncementId(registerCommentReaction),
		unregisterCommentReaction: withAnnouncementId(unregisterCommentReaction),
		updateCommentReaction: withAnnouncementId(updateCommentReaction),
		doesUserHaveAccess: withAnnouncementId(doesUserHaveAccess),
		findUsers: withAnnouncementId(findUsers),
		getCommentsList: withAnnouncementId(getCommentsList),
		getCommentImageUrl: getAnnouncementCommentImageUrl
	};
}

function getAnnouncementCommentImageUrl(imageId: string): string {
	return createUrlRelativeToEnvironment(
		`/Hub/Announcements/Comments/Image/?imageId=${encodeURIComponent(imageId)}`
	);
}
